import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static values = { counter: String };
  connect() {
    if(document.documentElement.hasAttribute("data-turbo-preview")) return;
    if(!/^\d+$/.test(this.counterValue)) return;
    if(!window.ym) { window.ym = function() { (window.ym.a = window.ym.a || []).push(arguments); }; window.ym.l = Date.now(); const script = document.createElement("script"); script.src = "https://mc.yandex.ru/metrika/tag.js"; script.async = true; document.head.append(script); }
    window.rocketCounters ||= new Set();
    const id = Number(this.counterValue);
    if(!window.rocketCounters.has(id)) { window.ym(id, "init", { defer: true, clickmap: false, trackLinks: true, accurateTrackBounce: true, webvisor: false }); window.rocketCounters.add(id); }
    const url = new URL(location.href); url.search = ""; url.hash = "";
    window.ym(id, "hit", url.href, { title: document.title });
    const goal = this.element.querySelector("[data-analytics-goal='lead_success']");
    if(goal) { window.ym(id, "reachGoal", "lead_success"); goal.remove(); }
  }
}
